class WABartenderChallenge {
  constructor(root) {
    this.root = root;
    this.triggers = [...root.querySelectorAll('[data-wa-entry-open]')];
    this.dialogs = [...root.querySelectorAll('[data-wa-entry-dialog]')];
    this.lastTrigger = null;
    this.bind();
  }

  bind() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.open(trigger));
    });

    this.dialogs.forEach((dialog) => {
      dialog.querySelector('[data-wa-entry-close]')?.addEventListener('click', () => this.close(dialog));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) this.close(dialog);
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('wa-challenge-dialog-open');
        this.lastTrigger?.focus();
      });
    });
  }

  open(trigger) {
    const dialog = this.root.querySelector(`#${CSS.escape(trigger.dataset.waEntryOpen)}`);
    if (!dialog) return;
    this.lastTrigger = trigger;
    document.body.classList.add('wa-challenge-dialog-open');
    dialog.showModal();
  }

  close(dialog) {
    if (dialog?.open) dialog.close();
  }
}

const initializeWABartenderChallenges = (scope = document) => {
  scope.querySelectorAll('[data-wa-challenge]:not([data-wa-challenge-ready])').forEach((root) => {
    root.dataset.waChallengeReady = 'true';
    new WABartenderChallenge(root);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeWABartenderChallenges(), { once: true });
} else {
  initializeWABartenderChallenges();
}

document.addEventListener('shopify:section:load', (event) => initializeWABartenderChallenges(event.target));
